// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import docImage from '../../assets/doc_image.png';
import { toggleModal } from '../../storage/actions/modalsActions';
import { reloadData } from '../../storage/actions/applicationStateActions';
import Notification from '../notification';

const ImportRecruitsModal = ({ modalState, toggleModal: toggleModalAction, reloadData: reloadDataAction }) => {
  const [file, setFile] = useState(null);
  const [messageImportFile, setMessageImportFile] = useState(null);

  const closeModal = () => {
    setFile(null);
    setMessageImportFile(null);
    toggleModalAction(false, 'importRecruitsModal');
  };

  const handlerUploadFile = () => {
    if (!file) {
      setMessageImportFile('Please select file to import.');
      return;
    }
    if (!file.type.includes('csv') && !file.type.includes('excel')) {
      setMessageImportFile('Please select .csv file to import.');
      return;
    }
    setMessageImportFile('');
    toggleModalAction(true, 'loader', true);
    const fd = new FormData();
    fd.append('file', file);

    axios
      .post('/api/recruits/import', fd)
      .then((res) => {
        const notificationType = res.data?.success ? 'info' : 'error';
        Notification(notificationType, {
          message: res.data.message,
        });
        if (res.data.skippedLines) {
          setMessageImportFile(
            `Skipped lines on upload process <br> ${res.data.skippedLines.join('<br>')} <br> Please check email or zip!`,
          );
        } else {
          closeModal();
        }
      })
      .catch((error) => {
        console.error('Import Recruits Error: ', error);
        setMessageImportFile(error.response?.data?.message || error.message);
      })
      .finally(() => {
        toggleModalAction(false, 'loader', true);
        reloadDataAction();
      });
  };

  const handlerFile = (event) => {
    if (!event.target.files[0]) {
      setFile(null);
      setMessageImportFile('Please select .csv file to import.');
      return;
    }
    setFile(event.target.files[0]);
    setMessageImportFile('');
  };

  if (!modalState?.isOpen) {
    return null;
  }

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="import-recruits-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="import-recruits-title">
            Import Recruits
          </div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          <div className="info_block">
            <div className="block_sub">Select your CSV file to import</div>
          </div>
          <div className="add_btns">
            <label className="standard_btn icon_upload">
              <input type="file" name="file_attach" onChange={handlerFile} accept=".csv" />
              Choose file
            </label>
            {messageImportFile && (
              <div
                className="import_error"
                dangerouslySetInnerHTML={{ __html: messageImportFile }}
              />
            )}
          </div>
          {file && (
            <div className="field_col">
              <div className="import_preview">
                <img src={docImage} alt="" />
                <span>{file.name}</span>
              </div>
            </div>
          )}
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            aria-label="upload"
            onClick={handlerUploadFile}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  modalState: state.modalState.importRecruitsModal,
});

export default connect(mapStateToProps, { toggleModal, reloadData })(ImportRecruitsModal);
